import OAuthCallback from '../views/OAuthCallback';
import MobileCallback from '../views/MobileCallback';
import IframeCallback from '../views/IframCalback';

const router = [
  {
    name: 'auth.oauthCallback',
    path: '/oauth_callback/:provider',
    component: OAuthCallback,
    meta: {
      requiresAuth: false,
      requiresTeacherRole: false,
    },
  },
  {
    name: 'auth.mobileCallback',
    path: '/mobile_callback/:provider',
    component: MobileCallback,
    meta: {
      requiresAuth: false,
      requiresTeacherRole: false,
    },
  },
  {
    name: 'auth.iframeCallback',
    path: '/iframe_callback/:provider',
    component: IframeCallback,
    meta: {
      requiresAuth: false,
      requiresTeacherRole: false,
    },
  },
];

export default router;
